import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Form } from 'semantic-ui-react'
import { DangerText, ScreenHeight, TitleText, ImageContainer } from 'components'
import { AppPrimaryButton, CommanAuthScreenLogin, FormPasswordFormField } from "elements";
import { DefaultText, InviteUserService } from "utility";
import { Images } from "assets";
import { useTabletAndBelowMediaQuery } from "layout";

import { useNotification } from "hooks/toast";

const PasswordSchema = yup.object().shape({
    Password: yup.string().trim("Spaces not allowed").strict().required('Password is required')
        .min(8, 'Password is too short - should be 8 chars minimum.'),
    confirmPassword: yup.string().trim("Spaces not allowed").strict().oneOf([yup.ref('Password'), null], 'Passwords must match'),
})

export const SetPasswordScreen = () => {
    const { successToast } = useNotification()

    const isMobile = useTabletAndBelowMediaQuery()

    const navigate = useNavigate();
    const [processing, setProcessing] = useState('');
    const [error, setError] = useState('');
    const { state: invites } = useLocation()
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(PasswordSchema),
    })
    const submit = async (formData) => {
        try {
            setProcessing('Processing')
            setError('')
            await InviteUserService.inviteSetPassword({
                InviteTo: invites?.InviteTo,
                InviteCode: invites?.InviteCode,
                Password: formData.Password,
            })
            successToast('Password set successfully')
            navigate("/")
        } catch (error) {
            console.log(error)
            setError(DefaultText.defaultError)
        } finally {
            setProcessing('')
        }
    }

    return (
        <ScreenHeight className="container ">
            <CommanAuthScreenLogin isMobile={isMobile}>
                <TitleText>
                    {' '}
                    <ImageContainer
                        src={Images.Logo}
                        className="img"
                    />
                    <span>Set Password</span>
                </TitleText>
                <Form
                    noValidate
                    onSubmit={handleSubmit(submit)}
                    className="mt-5"
                >
                    <FormPasswordFormField
                        control={control}
                        label="Password"
                        name="Password"
                        placeholder="Password"
                        errors={errors?.password}
                        defaultValue=""
                    />
                    <FormPasswordFormField
                        control={control}
                        label="Confirm Password"
                        name="confirmPassword"
                        placeholder="confirm Password"
                        errors={errors?.confirmPassword}
                        defaultValue=""
                    />
                    {error && <DangerText>{error}</DangerText>}
                    <AppPrimaryButton loading={processing} fluid className="mt-2">Verify</AppPrimaryButton>
                    <Link to="/" className="d-flex justify-content-center">
                        <div basic className="mt-3">Log in</div>
                    </Link>
                </Form>
            </CommanAuthScreenLogin>
        </ScreenHeight>
    )
}
